import $ from 'jquery'

function CustomMarkerLabel(opts) {
    this.latlng_ = opts.latlng
    this.title = opts.title
    this.visible = opts.visible

    this.setMap(opts.map)
}

CustomMarkerLabel.prototype = new google.maps.OverlayView()

CustomMarkerLabel.prototype.draw = function() {
    this.color = {
        default: '#45a4fc',
        hover: '#ef8f22',
        border: '#1f8ef5',
    }
    this.selected = false

    if (!this.div_) {
        var panes = this.getPanes()
        this.div_ = $('<div>' + this.title + '</div>').css({
            position: 'absolute',
            display: 'block',
            'background-color': this.color.default,
            'font-family': 'proxima-nova, sans-serif',
            'font-size': '12px',
            color: '#000',
            'text-align': 'center',
            'border-radius': '3px',
            border: '1px solid ' + this.color.border,
            'max-width': '75px',
            padding: '3px 5px',
            overflow: 'hidden',
            'text-overflow': 'ellipsis',
            'white-space': 'nowrap',
            'z-index': 1,
            transform: 'translateX(-50%)',
            transition: 'all .2s',
        })
        this.setVisible(this.visible)
        panes.floatPane.appendChild(this.div_[0])
    }
    var pixPosition = this.getProjection().fromLatLngToDivPixel(this.latlng_)
    if (!pixPosition) return
    this.div_.css({
        left: pixPosition.x + 5 + 'px',
        top: pixPosition.y - 60 + 'px',
    })
}
CustomMarkerLabel.prototype.setVisible = function(visible) {
    this.div_ && this.div_.css({ display: visible ? 'block' : 'none' })
}
CustomMarkerLabel.prototype.setHover = function(hovered) {
    this.div_ &&
        this.div_.css({
            'z-index': hovered ? 3 : this.selected ? 2 : 1,
            'max-width': hovered ? '300px' : '75px',
        })
}
CustomMarkerLabel.prototype.setSelected = function(selected) {
    this.selected = selected
    this.div_ &&
        this.div_.css({
            'z-index': selected ? 2 : 1,
            'max-width': '75px',
        })
}

export default CustomMarkerLabel
